"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAmplitudeTransport = void 0;
var analyticsEventName_1 = __importDefault(require("./analyticsEventName"));
var sanitizeUserId = function (userId) {
    if (!userId)
        return undefined;
    return String(userId).padStart(5, '0');
};
var isExcludedTeamAndProjectEvent = function (eventName) {
    return [
        analyticsEventName_1.default.SIGNED_IN.toString(),
        analyticsEventName_1.default.SIGNED_OUT.toString(),
        analyticsEventName_1.default.REGISTRATION_FORM_COMPLETED.toString(),
    ].includes(eventName.toString());
};
var setAmplitudeTransport = function (transport) {
    if (transport === void 0) { transport = 'fetch'; }
    var amplitudeLoaded = typeof amplitude !== 'undefined';
    if (!amplitudeLoaded) {
        return;
    }
    amplitude.setTransport(transport);
    amplitude.flush();
};
exports.setAmplitudeTransport = setAmplitudeTransport;
var track = function (eventName, eventProperties, userId) {
    var _a, _b;
    if (eventProperties === void 0) { eventProperties = {}; }
    if (userId === void 0) { userId = null; }
    var amplitudeLoaded = typeof amplitude !== 'undefined';
    if (!amplitudeLoaded) {
        return;
    }
    // Use argument user id as a priority in case we need to force pass it
    // This is a rare occurrence and only happens with calls where context
    // from backend session has not been set, like signup
    var externalUserId = userId || (amplitudeData === null || amplitudeData === void 0 ? void 0 : amplitudeData.userId);
    if (externalUserId) {
        var sanitizedUserId = sanitizeUserId(externalUserId);
        amplitude.setUserId(sanitizedUserId);
    }
    var includeAdditionalEventData = typeof analyticsAdditionalEventData !== 'undefined' && !isExcludedTeamAndProjectEvent(eventName);
    try {
        if (amplitudeLoaded) {
            if (includeAdditionalEventData) {
                var groups = analyticsAdditionalEventData && __assign(__assign({}, (((_a = analyticsAdditionalEventData.project) === null || _a === void 0 ? void 0 : _a.project_id) && {
                    Projects: analyticsAdditionalEventData.project.project_id.toString(),
                })), (((_b = analyticsAdditionalEventData.team) === null || _b === void 0 ? void 0 : _b.team_id) && {
                    Teams: analyticsAdditionalEventData.team.team_id.toString(),
                }));
                amplitude.track({
                    event_type: eventName.toString(),
                    event_properties: eventProperties,
                    groups: groups,
                });
            }
            else {
                amplitude.track({ event_type: eventName.toString(), event_properties: eventProperties });
            }
        }
    }
    catch (e) {
        // Just in case
    }
};
exports.default = track;
